import { destroy, get, patch, post, put } from '../../../../api/axios';
import { type ApiResponse } from '../../../../api/core/_models';
import { NotificationsEndpoints } from '../../../../api/endpoints/NotificationsEndpoints';
import { PushNotificationEndpoints } from '../../../../api/endpoints/PushNotificationEndpoints';
import { type CreatePushNotificationRequestDto } from '../../../models/CreatePushNotificationRequestDto';
import { type ListData } from '../../../models/ListData';
import { type NotificationDto } from '../../../models/NotificationDto';
import { type PushNotificationResponseDto } from '../../../models/PushNotificationResponseDto';
import { type UpdatePushNotificationRequestDto } from '../../../models/UpdatePushNotificationRequestDto';

export const listNotification = (
  sort: string = 'registration_date',
  direction: string = 'desc',
  pageSize: number = 5,
  read: boolean = false,
) => {
  return post<ListData<NotificationDto>>(NotificationsEndpoints.list, {
    sort,
    direction,
    per_page: pageSize,
    filter: {
      read,
    },
  });
};

export const getNotificationDetails = (id: string) => {
  return get(NotificationsEndpoints.details(id));
};

export const removeNotification = (id: string) => {
  return destroy(NotificationsEndpoints.delete(id));
};

export const readNotification = (id: string) => {
  return patch(NotificationsEndpoints.read(id));
};

export const unreadNotification = (id: string) => {
  return patch(NotificationsEndpoints.unread(id));
};

export const readAllNotifications = () => {
  return patch(NotificationsEndpoints.readAll);
};

export const removeBatch = (ids: string[]): Promise<ApiResponse<string>> => {
  return post<string>(NotificationsEndpoints.deleteBatch, { ids });
};

export const readBatch = (ids: string[]): Promise<ApiResponse<string>> => {
  return post<string>(NotificationsEndpoints.readBatch, { ids });
};

export const sendPushNotification = (payload: CreatePushNotificationRequestDto) => {
  return post<PushNotificationResponseDto>(PushNotificationEndpoints.add, payload);
};

export const updatePushNotification = (id: string, payload: UpdatePushNotificationRequestDto) => {
  return put<PushNotificationResponseDto>(PushNotificationEndpoints.update(id), payload);
};

export const sendDraftPushNotification = (id: string) => {
  return post<PushNotificationResponseDto>(PushNotificationEndpoints.send(id));
};

export const cancelPushNotification = (id: string) => {
  return post<PushNotificationResponseDto>(PushNotificationEndpoints.cancel(id));
};

export const getPushNotificationDetails = (id: string) => {
  return get<PushNotificationResponseDto>(PushNotificationEndpoints.details(id));
};
